import React, { FC, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ActivityServiceContext } from '../../providers/ActivityServiceProvider';
import { getActivitiesByCustomerId, init, selectActivities, selectAllFilters, selectAppState, selectPageSize, setAppState, setCustomerId } from '../../redux/activityHistorySlice';
import { useAppDispatch } from '../../redux/store';
import MainLayout from '../layouts/MainLayout';
import EmptyHistory from '../presenters/EmptyHistory';
import MainHeader from '../presenters/MainHeader';
import FiltersContainer from './FiltersContainer';
import TimelineContainer from './TimelineContainer';

interface IProps {
  customerId: string;
  hideSensitiveAgentInformation: boolean;
}

const MainContainer: FC<IProps> = ({ customerId, hideSensitiveAgentInformation }) => {
  const service = useContext(ActivityServiceContext);

  const dispatch = useAppDispatch();

  const appState = useSelector(selectAppState);
  const activities = useSelector(selectActivities);
  const pageSize = useSelector(selectPageSize);
  const filters = useSelector(selectAllFilters);

  const [activitiesFetchTimer, setActivitiesFetchTimer] = useState<NodeJS.Timeout>();
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  const noActivities = appState === 'idle' && activities.length === 0 && filters.length === 0;

  useEffect(
    () => {
      dispatch(setCustomerId(customerId));
      dispatch(setAppState('init'));
    },
    [dispatch, customerId]
  );

  useEffect(
    () => {
      if (service && customerId && appState === 'init') {
        dispatch(init({ service, paging: { skip: 0, top: pageSize } }));
      }
    },
    [appState, customerId, service, pageSize, dispatch, activities]
  );

  useEffect(
    () => {
      if (appState === 'fetchActivities') {
        dispatch(setAppState('fetchingActivities'));
        if (activitiesFetchTimer) {
          clearTimeout(activitiesFetchTimer);
        }
        const timer = setTimeout(() => dispatch(getActivitiesByCustomerId({ service, paging: { skip: 0, top: pageSize } })), 2000);
        setActivitiesFetchTimer(timer);

        if (activitiesFetchTimer) clearTimeout(activitiesFetchTimer);
      }
    },
    [dispatch, pageSize, activitiesFetchTimer, setActivitiesFetchTimer, service, customerId, appState]
  );

  return <>
    {
      noActivities ?
        <EmptyHistory />
        :
        <MainLayout
          header={<MainHeader isOpen={isFiltersOpen} onExpand={() => setIsFiltersOpen(!isFiltersOpen)} />}
          filters={isFiltersOpen && <FiltersContainer hideSensitiveAgentInformation={hideSensitiveAgentInformation} />}
          timeline={<TimelineContainer activities={activities} hideSensitiveAgentInformation={hideSensitiveAgentInformation} />}
        />
    }
  </>;
};

export default MainContainer;